import { Component, h, Host, Prop, State } from '@stencil/core';
import { pathStore } from '@store/path-store';
import { handleRedirectWithDisclaimerLogic } from '@utils/utilities';
import { Disclaimer } from '../../../shared/types';
import { CardBenefitIconProps, CardBenefitsIconsSectionProps } from '../types';

@Component({
  tag: 'card-benefits',
  styleUrl: 'card-benefits.scss',
  shadow: true
})
export class CardBenefits {
  @Prop() data: CardBenefitsIconsSectionProps;
  // Redirect Popup Related Code
  @State() showRedirectPopup: boolean = false;
  @State() redirectPopupContentType: string;
  @State() redirectTargetUrl: string = '';
  @State() disclaimerContent: Disclaimer

  handleRedirectProceed = () => {
    if (this.redirectTargetUrl) {
      window.location.href = this.redirectTargetUrl;
    }
  };

  handleRedirectClose = () => {
    this.showRedirectPopup = false;
  };

  onCardClick = (event: Event, item) => {
    event.stopPropagation();
    event.preventDefault();

    const { redirectUrl, disclaimer_popup, openRedirectUrlInNewTab } = item;

    const result = handleRedirectWithDisclaimerLogic({
      redirectUrl: redirectUrl,
      disclaimerSlug: disclaimer_popup?.slug,
      openInNewTab: openRedirectUrlInNewTab
    });

    if (result.showPopup) {
      this.redirectPopupContentType = result.contentType;
      this.redirectTargetUrl = result.redirectUrl;
      this.disclaimerContent = result.disclaimerContent;
      this.showRedirectPopup = true;
    }

  };

  render() {
    const assetPath = pathStore.assetPath;

    return (
      <Host>
        <slot>
          <div>
            <div class="flex justify-between py-4 features-container p-4">
              <p class="text-base font-bold text-black leading-6">{this.data?.title}</p>
              {this.data.viewAllLink && (
                <a href={this.data?.viewAllLink}>
                  <img src={`${assetPath}images/icons/right_circle_arrow.svg`} alt={`${this.data?.title}`} height="16" />
                </a>
              )}
            </div>
            <div class="flex justify-evenly features-scroll-wrapper">
              {this.data?.card_benefits_icons?.map((feature: CardBenefitIconProps) => (
                <div class="feature-item ">
                  <a href={feature.redirectUrl} target="_blank" class="feature-item clickable" onClick={e => this.onCardClick(e, feature)}>
                    <div class="icon-wrapper">
                      <img src={`${feature.Icon.url}`} alt={feature.title} class="icon" />
                    </div>
                    <p class="title">{feature.title}</p>
                  </a>
                </div>
              ))}
            </div>
          </div>
          {this.showRedirectPopup && (
            <redirect-popup
              open={this.showRedirectPopup}
              contentType={this.redirectPopupContentType}
              onConfirm={this.handleRedirectProceed}
              onClose={this.handleRedirectClose}
              redirectTargetUrl={this.redirectTargetUrl}
            />
          )}
        </slot>
      </Host>
    );
  }
}
